import { defineMessages } from 'react-intl';
export var messages = defineMessages({
  addCreditsSuccess: {
    id: 'classBundles.modal.credits.success',
    defaultMessage: 'Success! Your add on credits have been added to your plan.'
  }
});